export function formatDuration(seconds: number): string {
  console.log(seconds);
  return seconds.toFixed(2);
}